// extracted by mini-css-extract-plugin
module.exports = {"Reviews":"Reviews_Reviews__IGYfi","grid":"Reviews_grid__s0BZJ","Reviews-empty":"Reviews_Reviews-empty__e4VhO"};